(function(window, document, undefined) {

  const
    activateEmbedProviderEventName = 'vodl_activate_embed_provider',
    minHeight = 200,
    playlistWidgetBaseClass = 'vodl-yt-playlist',
    playlistWidgetBoxClass = playlistWidgetBaseClass + '__box',
    playlistWidgetId = 'vodl-vimeo-playlist',
    scrollDistance = window.screen.availHeight * 0.1,
    tcfStorageKey = 'tcf-status',
    userStorageKey = 'user-status'
  ;

  let maxHeight = 250,
    isRiver = false;

  // Logger instance with film frames emoji prefix.
  let logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F39E)) || { log: function() { } };
  }  catch(e) {
    logger = { log: function() { } };
  }

  // Storage access to immediately get userStatus and tcfStatus.
  let storage = {};
  try {
    storage = window.RussMedia.Utils.LocalStorage;
  } catch(e) {
    storage = {
      get: function() {
        return null;
      },
      set: function() {
        return false;
      },
      remove: function() {
        return;
      }
    };
  }

  /**
   * Inititalize everything:
   * - find the playlist widget on the page, if any
   * - attach event handlers to open/close the widget
   * - determine opening mode (click, scroll, instant)
   *
   * @return {undefined}
   */
  const init = function() {

    // Get the widget wrapper.
    playlistWidget = document.getElementById(playlistWidgetId);
    if (!playlistWidget) {
      // Nothing to do here, exit.
      logger.log('no vimeo playlist widget found, skipping.');
      return;
    }

    // Let's get the tcfStatus and userStatus from storage.
    // That way we may know early if we can show the video player to the user
    // by setting videoPlayer.consentGiven = true.
    let
      tcfStatus = storage.get(tcfStorageKey),
      userStatus = storage.get(userStorageKey) || {}
    ;

    let isPureSubscriber = userStatus.pureSubscriber || false;
    if (isPureSubscriber) {
      // Check on pureSubscriber first
      userStatus.consentSettings = userStatus.consentSettings || {};
      videoPlayer.consentGiven = userStatus.consentSettings.vimeo || false;
      logger.log('consent for vimeo playlist widget from user-state:', videoPlayer.consentGiven);
    } else if (tcfStatus) {
      // If user is no pureSubscriber we still can check tcf consent.
      videoPlayer.consentGiven = true;
      logger.log('consent for vimeo playlist widget from tcf-state:', videoPlayer.consentGiven);
    }

    // Get the inner box of the widget.
    playlistWidgetBox = playlistWidget.querySelector('.' + playlistWidgetBoxClass);

    // isMobile and isBreaking will decide which setting we use to determine the opening mode.
    isMobile = window.matchMedia('(max-width: 37rem)').matches;
    isBreaking = playlistWidgetBox.classList.contains(playlistWidgetBoxClass + '--breaking');
    isRiver = playlistWidgetBox.classList.contains(playlistWidgetBoxClass + '--river-widget');

    // Determine opening behaviour - click, scroll or instant.
    let openingBehaviour = 'click';
    if (isMobile) {
      openingBehaviour = playlistWidget.dataset.openingMobile || 'click';
    } else {
      openingBehaviour = playlistWidget.dataset.openingDesktop || 'click';
    }
    // Breaking news mode overrules everything.
    if (isBreaking) {
      openingBehaviour = playlistWidget.dataset.openingBreaking || 'click';
    }
    if (isRiver) {
      maxHeight = 420;
    }
    logger.log('widget inititalizing: isMobile:', isMobile, 'isBreaking:', isBreaking, 'openingBehaviour:', openingBehaviour);

    // Add event listener for activating (the vimeo) embed provider.
    document.addEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);

    // Get the open- and closeButton and attach click event handlers.
    openButton = playlistWidget.querySelector('.' + playlistWidgetBoxClass + '-open');
    closeButton = playlistWidget.querySelector('.' + playlistWidgetBoxClass + '-close');

    if (closeButton) {
      closeButton.addEventListener('click', events.onCloseButtonClick);
    }

    if (openButton) {
      openButton.addEventListener('click', events.onOpenButtonClick);
    }

    // Get the mute- and unmuteButton and attach click event handlers.
    muteButton = playlistWidget.querySelector('.' + playlistWidgetBoxClass + '-audio--mute');
    unmuteButton = playlistWidget.querySelector('.' + playlistWidgetBoxClass + '-audio--unmute');

    if (muteButton) {
      muteButton.addEventListener('click', events.onMuteButtonClick);
    }

    if (unmuteButton) {
      unmuteButton.addEventListener('click', events.onUnmuteButtonClick);
    }

    // Add scroll event handler if 'scroll' is the openingBehaviour.
    if ('scroll' === openingBehaviour) {
      document.addEventListener('scroll', events.onScroll, {passive: true});
    }

    // Add a DOMContentLoaded event handler for 'isntant' openingBehaviour.
    if ('instant' === openingBehaviour) {
      document.addEventListener('DOMContentLoaded', () => {
        window.setTimeout(() => { events.onOpenButtonClick(); }, 2000);
      });
    }

  };


  /**
   * A collection of event handlers.
   *
   * @type {Object}
   */
  const events = {

    /**
     * Eventhandler for handling activation of the Vimeo embed provider.
     * ev.detail.provider should contain the provider slug.
     * Will set videoPlayer.consentGiven = true if provider slug is 'vimeo' or '*'.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onActivateEmbedProvider: function(ev) {

      let activatedProvider = ev.detail.provider || false;
      if (!activatedProvider) {
        return;
      }

      if ('*' === activatedProvider || 'vimeo' === activatedProvider) {
        logger.log('consent for Vimeo playlist widget available!');

        // IF there is no consent YET, we save it now
        // Furthermore we try to start the video if the widget.isOpen().
        if (!videoPlayer.consentGiven) {
          videoPlayer.consentGiven = true;
          if (widget.isOpen()) {
            videoPlayer.start();
          }
        }
      }
    },

    /**
     * Click event handler for the closeButton.
     *  - stop the videoPlayer
     *  - close the widget
     *
     * @return {undefined}
     */
    onCloseButtonClick: function() {
      videoPlayer.stop();
      widget.close();
    },

    /**
     * Click event handler for the muteButton.
     *  - mute the videoPlayer
     *  - toggleUnmuteButton in the widget
     *
     * @return {undefined}
     */
    onMuteButtonClick: function() {
      videoPlayer.mute();
    },

    /**
     * Click event handler for the openButton.
     *  - remove scroll event handler
     *  - open the widget
     *  - start the videoPlayer with slight delay
     *
     * @return {undefined}
     */
    onOpenButtonClick: function() {
      // The possibly existing scroll event handler
      // should now be removed, as the widget was already opened manualy.
      document.removeEventListener('scroll', events.onScroll);
      widget.open();
      // Start the video with slight delay to better fit the opening transition.
      window.setTimeout(() => { videoPlayer.start(); }, 500);
    },

    /**
     * A throttled window resize handler to resize the videoPlayer accordingly.
     *
     * @return {undefined}
     */
    onResize: function() {
      window.clearTimeout(videoPlayer.resizeTimer);
      videoPlayer.resizeTimer = window.setTimeout(() => { videoPlayer.resize(); }, 200);
    },

    /**
     * Scroll event handler.
     * Only used if the openingBehaviour is 'scroll'.
     * Will open the widget via onOpenButtonClick() if scrollDistance is reached.
     *
     * @return {undefined}
     */
    onScroll: function() {
      if (scrollDistance < window.scrollY) {
        logger.log('onScroll: scrollDistance reached');
        events.onOpenButtonClick();
      }
    },

    /**
     * Click event handler for the unmuteButton.
     *  - unmute the videoPlayer
     *  - toggleMuteButton in the widget
     *
     * @return {undefined}
     */
    onUnmuteButtonClick: function() {
      videoPlayer.unmute();
    },


    onVolumeChange: function(data) {
      logger.log('onVolumeChange:', data);

      videoPlayer.vimeoPlayer.getMuted().then(function(muted) {
        logger.log('onVolumeChange muted:', muted);
        if(muted) {
          widget.toggleUnmuteButton();
        } else {
          widget.toggleMuteButton();
        }
      });
    }

  };


  /**
   * Provides access to widget features like open() and close().
   *
   * @type {Object}
   */
  const widget = {
    closedClass: playlistWidgetBoxClass + '--minimized',
    openClass: playlistWidgetBoxClass + '--maximized',

    /**
     * Checks if widget is currently closed.
     *
     * @return {Boolean} true if closed, false otherwise.
     */
    isClosed: function() {
      return playlistWidgetBox.classList.contains(this.closedClass);
    },

    /**
     * Checks if widget is currently open.
     *
     * @return {Boolean} true if open, false otherwise.
     */
    isOpen: function() {
      return playlistWidgetBox.classList.contains(this.openClass);
    },

    /**
     * Closes the widget.
     *
     * @return {undefined}
     */
    close: function() {
      if (this.isClosed()) {
        return;
      }
      playlistWidgetBox.classList.add(this.closedClass);
      playlistWidgetBox.classList.remove(this.openClass);
    },

    /**
     * Opens the widget.
     *
     * @return {undefined}
     */
    open: function() {
      if (this.isOpen()) {
        return;
      }
      playlistWidgetBox.classList.add(this.openClass);
      playlistWidgetBox.classList.remove(this.closedClass);
    },

    /**
     * Shows the muteButton and hides the unmuteButton.
     *
     * @return {undefined}
     */
    toggleMuteButton: function() {
      muteButton.style.display = 'block';
      unmuteButton.style.display = 'none';
    },

    /**
     * Shows the unmuteButton and hides the muteButton.
     *
     * @return {undefined}
     */
    toggleUnmuteButton: function() {
      unmuteButton.style.display = 'block';
      muteButton.style.display = 'none';
    }
  };


  /**
   * Provides access to video player features like start() and stop().
   *
   * @type {Object}
   */
  const videoPlayer = {

    consentGiven: false,
    resizeTimer: null,
    vimeoPlayer: false,


    /**
     * Will determine the 'optimalSize' of the video player by getting the available width
     * and calculating height according to the 16:9 aspect ratio.
     * minHeight and maxHeight are considered.
     *
     * @return {Object} Object with width and height properties.
     */
    getOptimalSize: function() {
      let width = playlistWidget.clientWidth;
      let height = width * 9/16;
      if (height > maxHeight) {
        height = maxHeight;
      } else if (height < minHeight) {
        // the player should have a min-height of 200px
        height = minHeight;
      }
      return { width, height };
    },

    /**
     * Returns a promise that will resolve() if
     *  - Vimeo API was already loaded some time before
     *  - Vimeo API could be loaded via script injection and indicated ready state
     * reject() will be caused by
     *  - failure while loading the Vimeo API
     *
     * @return {Promise} A promise
     */
    loadVimeoApi: function() {
      return new Promise((resolve, reject) => {
        if ('undefined' === typeof(window.Vimeo) || 'undefined' === typeof(window.Vimeo.Player)) {

          const tag = document.createElement('script');
          tag.async = true;
          tag.src = 'https://player.vimeo.com/api/player.js';
          tag.type = 'text/javascript';
          tag.onerror = function(error) {
            reject(error);
          };

          tag.onload = function() {
            logger.log('loadVimeoApi: ready');
            resolve();
          };

          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        } else {
          resolve();
        }
      });
    },

    /**
     * Returns a promise that will resolve() if
     *  - a Vimeo.Player instance has already been created before in this.vimeoPlayer OR
     *  - a Vimeo.Player instance is newly created in this.vimeoPlayer and is ready
     * reject() will be caused by
     *  - missing this.consentGiven
     *  - failure when loading the Vimeo API
     *
     * @return {Promise} A promise
     */
    maybeInitPlayer: function() {

      return new Promise((resolve, reject) => {

        logger.log('maybeInitPlayer....');

        if (!this.consentGiven) {
          reject(new Error('No consent for vimeo playlist widget given!'));
          return;
        }

        if (this.vimeoPlayer) {
          logger.log('Player already inititalized');
          resolve();
          return;
        }

        let placeholder = playlistWidgetBox.querySelector('.vodl-yt-playlist__placeholder');
        let optimalSize = this.getOptimalSize();
        let iframe = playlistWidgetBox.querySelector('iframe');

        iframe.setAttribute('width', optimalSize.width);
        iframe.setAttribute('height', optimalSize.height);

        logger.log('optimalSize:', optimalSize);

        this.loadVimeoApi().then(
          () => {
            logger.log('maybeInitPlayer: loadVimeoApi sucessfull');

            let iframeUrl = this.parseVideoIframeUrl(iframe.dataset.url);
            if (!iframeUrl) {
              reject(new Error('Invalid Vimeo URL.'));
            }

            iframe.src = iframeUrl;

            iframe.onload = () => {

              placeholder.classList.remove('vodl-yt-playlist__placeholder');
              this.vimeoPlayer = new window.Vimeo.Player(iframe);
              this.vimeoPlayer.on('volumechange', events.onVolumeChange);

              // We trigger the muteButton once manually here. This will mute the player
              // and set the widget buttons in the correct state.
              videoPlayer.mute();
              widget.toggleUnmuteButton();

              // Attach a window resize event listener to be able to resize the player.
              window.addEventListener('resize', events.onResize);

              resolve();
            };

          }, (error) => {
            reject(error);
          });
      });
    },

    /**
     * Mute the player by calling mute()
     * on the Vimeo.Player instance this.vimeoPlayer
     *
     * @return {undefined}
     */
    mute: function() {
      if (this.vimeoPlayer) {
        this.vimeoPlayer.setMuted(true);
      }
    },


    /**
     * Parses the given vimeoURL and returns a normalized version if there is a match.
     * The given vimeoUrl may either represent a single video, a showcase (aka playlist) or an event.
     * Depending on that the player iframe URL needs to be different:
     * single video - https://player.vimeo.com/video/76979871
     * playlist - https://vimeo.com/showcase/6137181/embed
     * event - https://vimeo.com/event/1116689/embed
     *
     * @param  {string} vimeoUrl the raw vimeoUrl
     * @return {string|boolean}  The normalized URL or false if there was no match.
     */
    parseVideoIframeUrl: function(vimeoUrl) {
      let rePlaylist = /showcase\/(\d+)/i;
      let playlistMatch = vimeoUrl.match(rePlaylist);

      if (playlistMatch && playlistMatch[1]) {
        logger.log('parseVideoIframeUrl playlistMatch:', playlistMatch);
        return 'https://vimeo.com/showcase/' + playlistMatch[1] +  '/embed';
      }

      let reEvent = /event\/(\d+)/i;
      let eventMatch = vimeoUrl.match(reEvent);

      if (eventMatch && eventMatch[1]) {
        logger.log('parseVideoIframeUrl eventMatch:', eventMatch);
        return 'https://vimeo.com/event/' + eventMatch[1] +  '/embed';
      }

      let reSingle = /.+\/(\d+)/i;
      let singleMatch = vimeoUrl.match(reSingle);

      if (singleMatch && singleMatch[1]) {
        logger.log('parseVideoIframeUrl singleMatch:', singleMatch);
        return 'https://player.vimeo.com/video/' + singleMatch[1];
      }

      logger.log('parseVideoIframeUrl no match:', vimeoUrl);
      return false;
    },

    /**
     * Does the actual resizing.
     *
     * @return {undefined}
     */
    resize: function() {
      if (this.vimeoPlayer) {
        let optimalSize = this.getOptimalSize();
        this.vimeoPlayer.element.style.width = optimalSize.width + 'px';
        this.vimeoPlayer.element.style.height = optimalSize.height + 'px';
      }
    },

    /**
     * Starts the video by:
     *  - waiting for maybeInitPlayer to resolve()
     *  - calling play() on the Vimeo.Player instance this.vimeoPlayer
     *
     * @return {undefined}
     */
    start: function() {
      this.maybeInitPlayer().then(
        () => {
          logger.log('start: trying to play video');
          this.vimeoPlayer.play();
        },
        (error) => {
          logger.log('maybeInitPlayer failed:', error);
        }
      );
    },

    /**
     * Stops the video by calling pause()
     * on the Vimeo.Player instance this.vimeoPlayer
     *
     * @return {undefined}
     */
    stop: function() {
      if (this.vimeoPlayer) {
        logger.log('stop: trying to stop video');
        this.vimeoPlayer.pause();
      }
    },

    /**
     * Unmute the player by calling unMute()
     * on the Vimeo.Player instance this.vimeoPlayer
     *
     * @return {undefined}
     */
    unmute: function() {
      if (this.vimeoPlayer) {
        this.vimeoPlayer.setMuted(false);
      }
    },
  };

  // Initialization
  init();

})(window, document);
